const getters = {
  list: state => state.list,
  isLoading: state => state.isLoading,
  isUploading: state => state.isUploading,
  isPaginating: state => state.isPaginating,
  filter: state => state.filter,
  hasEmpty: state => state.hasEmpty,
  header: state => state.header,
  all: state => state.all,
  isShowLoading: state => state.isShowLoading,
};
export default getters;
